export const GET_SERVICE_REMINDERS = "GET_SERVICE_REMINDERS";

export const ADD_SERVICE_REMINDER = "ADD_SERVICE_REMINDER";
export const EDIT_SERVICE_REMINDER = "EDIT_SERVICE_REMINDER";

export const SET_SELECTED_SRID = "SET_SELECTED_SRID";
export const CLEAR_SELECTED_SRID = "CLEAR_SELECTED_SRID";

export const SET_SERVICE_REMINDER_LOADING_STATUS = 'SET_SERVICE_REMINDER_LOADING_STATUS'